<section>
  <div class="container">
    @if (isUnified) {
    <h1 class="uc-page-title uc-display-sm uc-semibold" translate="unifiedShell.pages.checkOut"></h1>
    }
    <h5 translate="course.continueShopping"></h5>
    <p>{{"course.cartItems" | translate: { count: cartItems.length} }}</p>
    <div class="table-responsive">
      <table class="table text-center align-middle">
        <thead>
          <tr>
            <th scope="col" translate="course.number"></th>
            <th scope="col" translate="course.product"></th>
            <th scope="col" translate="course.price"></th>
            <th scope="col">{{'course.discount'|translate}} %</th>
            <th scope="col"><span class="visually-hidden" translate="unifiedComponents.deleteItem"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of cartItems; let i = index">
            <td>{{i + 1}}</td>
            <td>
              <a [routerLink]="['/course/details/' + item.id]" class="d-flex align-items-center justify-content-center">
                <img [alt]="isRtl ? item.courseTitleAr : item.courseTitle" loading="lazy" [src]="resources + item.courseImage">
                <span class="text-nowrap">{{isRtl ? item.courseTitleAr : item.courseTitle}}</span>
              </a>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <div *ngIf="item.discount" class="discount-price">
                  <span translate="course.reyalCurrency"></span>
                  <span>{{item.price}}</span>
                </div>
                <div *ngIf="item.priceAfterDiscount">
                  <span translate="course.reyalCurrency"></span>
                  <span>{{item.priceAfterDiscount}}</span>
                </div>
              </div>
            </td>
            <td>
              <div *ngIf="item.discount" class="discount">
                <span>{{item.discount}}</span>
              </div>
              <span *ngIf="!item.discount">0</span>
            </td>
            <td>
              <button type="button" (click)="deleteCartItem(item)" class="btn shadow-none border-0 bg-transparent"
                [attr.aria-label]="'unifiedComponents.deleteItem' | translate">
                <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/delete.svg);"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="course-coupon">
      <div class="d-flex align-items-center">
        <input id="typeText" type="text" class="form-control form-control-lg w-25 shadow-none" size="17" [placeholder]="'course.coupon'|translate" [attr.aria-label]="'course.coupon' | translate" minlength="3" maxlength="20" [(ngModel)]="coupon"/>
        <button *ngIf="!couponResponse" class="btn shadow-none border-0 text-white" (click)="applyCoupon()" type="button" translate="course.applyCoupon"></button>
        <button *ngIf="couponResponse" class="btn shadow-none border-0 text-white" (click)="couponResponse = null; coupon = ''; calcCouponDiscount()" type="button" translate="course.removeCoupon"></button>
      </div>
      <small class="text-danger">{{couponErrorMessage}}</small>
    </div>
    <ul>
      <li>
        <span translate="course.subTotal"></span>
        <div>
          <span translate="course.reyalCurrency"></span>
          <span>{{subTotal}}</span>
        </div>
      </li>
      <li>
        <span translate="course.discount"></span>
        <div>
          <span translate="course.reyalCurrency"></span>
          <span>{{ (subTotal - totalAfterDiscount) ? "-" + (subTotal - totalAfterDiscount) : 0 }}</span>
        </div>
      </li>
      <li *ngIf="couponResponse">
        <span translate="course.couponDiscount"></span>
        <div>
          <span translate="course.reyalCurrency"></span>
          <span>{{ couponDiscount ? "-" + couponDiscount : 0 }}</span>
        </div>
      </li>
      <li *ngIf="identityModel.vat > 0">
        <span translate="course.vat"></span>
        <span>{{identityModel.vat}}%</span>
      </li>
      <li>
        <span translate="course.total"></span>
        <div>
          <span translate="course.reyalCurrency"></span>
          <span>{{total}}</span>
        </div>
      </li>
    </ul>
    <div *ngIf="paymentError" class="alert alert-danger checkout-error d-flex align-items-center" role="alert">
      <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
      <p class="mb-0" translate="course.checkoutCart.paymentError"></p>
    </div>
    <button [disabled]="isLoading" (click)="createOrder()" class="btn mx-auto shadow-none border-0 d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <span class="d-flex align-items-center justify-content-center rounded-circle">
          <i class="fa-solid fa-arrow-right"></i>
        </span>
        <span class="text-white" translate="course.checkOut"></span>
      </div>
      <div class="d-flex align-items-center text-white">
        <span translate="course.reyalCurrency"></span>
        <span>{{total | number: '1.0-1'}}</span>
        <i *ngIf="isLoading" class="fa-solid fa-circle-notch fa-spin fa-2x text-white" style="transform-origin: center;"></i>
      </div>
    </button>
  </div>
</section>
